export const ID_FLOWS = {
  PERSONAL_INFO: 'Personal info',
  CONFIRM_IDENDITY: 'Confirm Identity',
  OTP: 'Otp',
};

export const DEFAULT_CURRENT_STEP_KEY = ID_FLOWS.PERSONAL_INFO;
